var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-image"},[_c('UploadImage',{ref:"uploadImageRef",attrs:{"maxNumber":3},on:{"on-change":_vm.onChange}}),_c('p',{staticStyle:{"color":"red"}},[_vm._v("\n    提示：①费用支出上传付款证明函；②税金支出上传报税证明；③工资支出上传工资发放证明\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }